const NotesFilters = [
  {
    name: 'Note author',
    pages: ['Notes'],
    type: 'membership',
    subtype: 'Teammates',
    searchState: 'NoteAuthorCondition',
    filterName: 'userId',
    options: [],
    prefix: 'noteAuthor',
    optionSelected: '',
    updateFilter: true,
  },
  {
    name: 'Exclude general notes',
    searchState: 'newAgencyPlanCondition',
    pages: ['Notes'],
    filterName: 'noteVisibility',
    filterValue: 'excludeGeneralNotes',
    type: 'toggle',
    value: false,
    notUseFromLocalStorage: true,
    tooltip: 'Exclude notes which are not related to any specific client',
  },
  {
    name: 'Association',
    pages: ['Notes'],
    filterName: 'contentType',
    optionSelected: '',
    options: [
      {
        name: 'Policymakers',
        filterValue: 'Stakeholder',
      },
      {
        name: 'Updates',
        filterValue: 'Stakeholder&contentTypeFilterIsNegative=true',
      },
    ],
  },
];

export default NotesFilters;
